/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiUserActionStatusFromJSON(json) {
    return ApiUserActionStatusFromJSONTyped(json, false);
}
export function ApiUserActionStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'leadStatusRuleId': !exists(json, 'leadStatusRuleId') ? undefined : json['leadStatusRuleId'],
        'leadStatusRuleName': !exists(json, 'leadStatusRuleName') ? undefined : json['leadStatusRuleName'],
    };
}
export function ApiUserActionStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'leadStatusRuleId': value.leadStatusRuleId,
        'leadStatusRuleName': value.leadStatusRuleName,
    };
}
